import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

import { ICampaignList } from '~/utils/interface/campaign';
import { handleGetCampaigns } from './campaignThunk';

export interface CampaignState {
  selectCampaigns: Array<ICampaignList>;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  campaigns: Array<ICampaignList>;
  selectedIds: Array<string>;
  campaignId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: CampaignState = {
  selectCampaigns: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  campaigns: [],
  campaignId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeCampaignId(state, action: PayloadAction<string>) {
      state.campaignId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetCampaigns.pending, (_state, _action) => {})

      .addCase(handleGetCampaigns.fulfilled, (state, action) => {
        state.campaigns = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetCampaigns.rejected, (_state, _action) => {});
  },
});

export const campaignActions = campaignSlice.actions;

const campaignReducer = campaignSlice.reducer;
export default campaignReducer;
